import React from 'react';
import Container from './Container';
import Icon from './Icon';

// Import content
import siteContent from '../content/site.json';

/**
 * Footer component
 * @returns {React.ReactElement} Footer component
 */
const Footer = () => {
  // Get content from site.json
  const { contact: contactInfo } = siteContent;

  return (
    <footer className="bg-brand-black text-ink pt-16 pb-8">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          {/* Logo and Contact */}
          <div>
            <div className="mb-6">
              <img 
                src="/assets/logo/logo-lsas-full.svg" 
                alt="Lone Star Aerial Solutions" 
                className="h-32 w-auto"
              />
            </div>
          </div>

          {/* Contact Info */}
          <div className="text-right">
            <div className="flex items-center justify-end mb-4">
              <Icon name="mail" className="mr-2 text-brand-blue-600" />
              <a href={`mailto:${contactInfo.email}`} className="text-white hover:text-brand-blue-600 transition-colors">
                {contactInfo.email}
              </a>
            </div>
            <div className="flex items-center justify-end mb-4">
              <Icon name="phone" className="mr-2 text-brand-blue-600" />
              <a href={`tel:${contactInfo.phone.replace(/[^0-9]/g, '')}`} className="text-white hover:text-brand-blue-600 transition-colors">
                {contactInfo.phone}
              </a>
            </div>
            <div className="flex items-center justify-end mb-4">
              <Icon name="pin" className="mr-2 text-brand-blue-600" />
              <span className="text-white">{contactInfo.serviceArea}</span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 text-center text-sm">
          <p>© {new Date().getFullYear()} Lone Star Aerial Solutions. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
